<!--FUNZIONA ATTRAVERSO VUEX IN MODO DA GESTIRLO FUORI IL ROUTER-->
<template>
  <div class="text-center">
    <v-dialog v-model="this.value" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          dialog_title
        }}</v-card-title>

        <v-card-text class="pt-4 pb-4">
          <div v-html="dialog_text"></div>
          <slot></slot>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="$emit('confirmFromDialog')"
            >Conferma</v-btn
          >
          <v-btn color="grey darken-2" text @click="$emit('cancelFromDialog')"
            >Annulla</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: ["value", "dialog_text", "dialog_title"],
  data() {
    return {
      // dialog_show: this.value
    };
  },
  methods: {},
};
</script>